// src/pages/HomePage.js
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/home/HeroSection';
import FocusAreasSection from '../components/home/FocusAreasSection';
import StatisticsSection from '../components/home/StatisticsSection';
import FeaturedProgramsSection from '../components/home/FeaturedProgramsSection';
import WhyChooseSection from '../components/home/WhyChooseSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CtaSection from '../components/home/CtaSection';
import PartnersSection from '../components/home/PartnersSection';
import { setupRevealAnimations } from '../utils/helpers';

const HomePage = () => {
  useEffect(() => {
    // Initialize animations
    setupRevealAnimations();
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Helmet>
        <title>Afrovate Tech Hub - Skills Against Poverty</title>
        <meta name="description" content="Afrovate Tech Hub Sierra Leone is a youth-owned and youth-led social enterprise empowering youth through marketable digital skills." />
        <meta name="keywords" content="Afrovate Tech Hub, Sierra Leone, digital skills, youth empowerment, BIM, CAD, programming, green skills, entrepreneurship" />
      </Helmet>
      
      <HeroSection />
      <FocusAreasSection />
      <StatisticsSection />
      <FeaturedProgramsSection />
      <WhyChooseSection />
      <TestimonialsSection />
      <CtaSection />
      <PartnersSection />
    </>
  );
};

export default HomePage;